/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function RoleEditor({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#RoleEditor_svg__a)"><path fill="currentColor" fillRule="evenodd" d="M7.747 1.904a4.6 4.6 0 0 1 6.506 6.506l-3.778 3.778a4.6 4.6 0 0 1-3.253 1.347H3.313l-1.389 1.39a.6.6 0 0 1-.848-.85l1.546-1.545V8.935a4.6 4.6 0 0 1 1.347-3.253l3.778-3.778Zm-.525 10.431H4.513L6.25 10.6h4.116l-.739.74a3.4 3.4 0 0 1-2.404.995Zm4.34-2.932 1.842-1.842a3.4 3.4 0 0 0-4.808-4.808L4.818 6.53a3.4 3.4 0 0 0-.996 2.404v2.395l5.254-5.254a.6.6 0 1 1 .848.848L7.45 9.4H11.5c.02 0 .042.001.062.003Z" clipRule="evenodd" /></g><defs><clipPath id="RoleEditor_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;